import { render, staticRenderFns } from "./ComprehensivePackage.vue?vue&type=template&id=b75e25d8&scoped=true&"
import script from "./ComprehensivePackage.vue?vue&type=script&lang=js&"
export * from "./ComprehensivePackage.vue?vue&type=script&lang=js&"
import style0 from "./ComprehensivePackage.vue?vue&type=style&index=0&id=b75e25d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75e25d8",
  null
  
)

export default component.exports